import Button from "@app/components/button"
import GradientContainer from "@app/components/gradient/gradient-container"
import TextGradient from "@app/components/gradient/gradient-text"
import { useState } from "react";

const MobileHoaResidential = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="pt-4 px-8 pb-8 bg-background-mid-em border-t">
      <div className="flex flex-col space-y-5 ">
        <TextGradient>
          <span className="h2">07</span>
        </TextGradient>
        <p className="mobile-h3 2xs:mobile-h2 text-background-primary-dark">
          HOAs & Residential
        </p>
        <GradientContainer overrideClassName="w-[30%] h-2" />
        <div className="text-text-color-mid-em-light space-y-5">
          <p>
            SimpleWaste represents HOA and residential communities nationwide.
          </p>
          <p>
            Our technology platform provides complete program and service visibility for
            HOA leadership and individual residents. With SimpleWaste, you can manage
            your refuse services with ease.
          </p>
          {isExpanded && (
            <div>
              <p>
                Benefit from our procurement agency by allowing SimpleWaste to
                represent your association.
              </p>
              <p>
                We negotiate your vendor options while providing a single point
                of contact experience through our sole source user interface.
                Residents can log in to check a pick-up status, request additional service options,
                or pay their bills.
              </p>
            </div>
          )}
        </div>
        <div>
          <Button onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? 'Read less' : 'Read more'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MobileHoaResidential;